import { Select } from 'client/components/core/Sidebar/components/Settings/components'
import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import HtmlAttrId from 'client/components/core/Sidebar/components/Settings/options/HtmlAttrId'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { usePage } from 'client/store/index'
import pageSelectors from 'client/store/page/pageSelectors'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { PriceElementInterface } from 'common/types/entities/price-element-interface'
import React from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import DeviceAppearanceNew from '../../options/DeviceAppearance/DeviceAppearanceNew'

interface PriceElementSettingsProps {
  entity: PriceElementInterface
  defaultEntity?: PriceElementInterface
}

export const PriceElementSettings = ({
  entity,
  defaultEntity,
}: PriceElementSettingsProps) => {
  const { isMobile } = useDeviceModeContext()

  const popups = usePage(pageSelectors.getWebsiteGlobalOrPagePopupEntities)(
    entity,
  )

  const updateProp = useUpdateProp(entity)

  const popupChoiceList = popups.reduce(
    (acc, popup) => ({
      // biome-ignore lint/performance/noAccumulatingSpread: <explanation>
      ...acc,
      [popup.id]:
        popup.type === EntityTypeEnum.Popup ? popup.title : popup.options.title,
    }),
    {},
  )

  return (
    <>
      <GroupTitle isFirst>Popups</GroupTitle>
      <Select
        labelText="entity_settings.price_element.first_plan"
        update={updateProp('popupIdFirstPlan')}
        choiceList={popupChoiceList}
        firstOption="entity_settings.button.choose_actions"
        value={entity.popupIdFirstPlan}
        skipTranslation
      />
      <Select
        labelText="entity_settings.price_element.second_plan"
        update={updateProp('popupIdSecondPlan')}
        choiceList={popupChoiceList}
        firstOption="entity_settings.button.choose_actions"
        value={entity.popupIdSecondPlan}
        skipTranslation
      />
      <Select
        labelText="entity_settings.price_element.second_plan_annual"
        update={updateProp('popupIdSecondPlanAnnual')}
        choiceList={popupChoiceList}
        firstOption="entity_settings.button.choose_actions"
        value={entity.popupIdSecondPlanAnnual}
        skipTranslation
      />
      <Select
        labelText="entity_settings.price_element.third_plan"
        update={updateProp('popupIdThirdPlan')}
        choiceList={popupChoiceList}
        firstOption="entity_settings.button.choose_actions"
        value={entity.popupIdThirdPlan}
        skipTranslation
      />
      <Select
        labelText="entity_settings.price_element.third_plan_annual"
        update={updateProp('popupIdThirdPlanAnnual')}
        choiceList={popupChoiceList}
        firstOption="entity_settings.button.choose_actions"
        value={entity.popupIdThirdPlanAnnual}
        skipTranslation
      />
      <Select
        labelText="entity_settings.price_element.fourth_plan"
        update={updateProp('popupIdFourthPlan')}
        choiceList={popupChoiceList}
        firstOption="entity_settings.button.choose_actions"
        value={entity.popupIdFourthPlan}
        skipTranslation
      />
      <Select
        labelText="entity_settings.price_element.fourth_plan_annual"
        update={updateProp('popupIdFourthPlanAnnual')}
        choiceList={popupChoiceList}
        firstOption="entity_settings.button.choose_actions"
        value={entity.popupIdFourthPlanAnnual}
        skipTranslation
      />
      <SizeAndPositionGroup
        margin={isMobile ? entity.mobileMargin : entity.margin}
        defaultMargin={
          isMobile ? defaultEntity?.mobileMargin : defaultEntity?.margin
        }
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
      />
      <DeviceAppearanceNew entity={entity} />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}
